import { withAuthGate } from '@sunrise-ui/composites';
import IntrosMadeView from '@templates/IntrosMadeView';
import React from 'react';

function PendingIntrosMadeScreen() {
  return <IntrosMadeView state="pending" />;
}

export default withAuthGate(PendingIntrosMadeScreen);
